// extracted by mini-css-extract-plugin
export default {"arrow":"wxHN_KhAnqlWmfaBHO85"};